
import React      from 'react';
import CSSModules from 'react-css-modules';

import classNames   from 'classnames/bind';

import style from './style.scss';

class ProgressBar extends React.Component {

    _getProgressWidth() {

        return this.props.progress + '%';
    }

    _getProgressLabel() {

        return this._getProgressWidth();
    }

    _getProgressClass() {

        var cx = classNames.bind(style);

        return cx({
            'progress': true,
            'progress--white': this.props.progress > 50
        });
    }

    render() {

        return (
            <div styleName="bar" { ...this.props }>

                <div className={ this._getProgressClass() } style={{ width: this._getProgressWidth() }}>

                    <div styleName="progress-text">{ this._getProgressLabel() } Complete</div>

                </div>

            </div>
        );
    }
}

export default CSSModules(ProgressBar, style);


// WEBPACK FOOTER //
// ./components/ProgressBar/index.js